module.exports = __webpack_public_path__ + "static/media/28.f1bbb0a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/28.wav
// module id = E4bQ
// module chunks = 0